export default __webpack_public_path__ + "static/media/Spiracle-small.de66d615.svg";